<template>
  <el-popover
    popper-class="app-popover"
    placement="bottom"
    trigger="click"
    @show="resetQrCode"
  >
    <template #reference>
      <i class="iconfont icona-bianzu5 app-icon"></i>
    </template>
    <template>
      <div v-rect-loading="loading" class="content">
        <div class="qr-code-wrapper">
          <img v-if="showQrCode" class="qr-code" :src="qrCodeUrl" @load="loadSuccess"/>
        </div>
        <div class="title">{{ $t('navBar.downloadApp') }}</div>
      </div>
    </template>
  </el-popover>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  components: {
  },
  data () {
    return {
      loading: false,
      showQrCode: false,
      qrCodeUrl: null
    }
  },
  computed: {
    ...mapGetters('account', ['getCurrentAccount'])
  },
  created () {
    const qrData = encodeURIComponent(`/passport/recruiter/login/?account_id=${this.getCurrentAccount.id}`)
    this.qrCodeUrl = `/django_rest/qr-code/?data=${qrData}&company_id=${this.getCurrentAccount.company_id}`
  },
  methods: {
    async resetQrCode () {
      this.loading = true
      this.showQrCode = false
      this.$nextTick(() => {
        this.showQrCode = true
      })
    },
    loadSuccess () {
      this.loading = false
    }
  }
}
</script>

<style lang="scss" scoped>
.app-icon {
  display: inline-block;
  margin-top: -3px;
  line-height: 1;
  font-size: 30px;
  vertical-align: middle;
  cursor: pointer;
  color: #939393;
}

.app-popover {
  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    width: 210px;
    padding: 20px;

    .qr-code-wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 120px;
      height: 120px;
      border-radius: 100%;
      background-color: #fff;
      box-shadow: 0px 2px 10px -4px #626262;
    }

    .qr-code {
      width: 86px;
    }

    .title {
      margin-top: 10px;
      color: #303133;
      font-size: 12px;
      line-height: 18px;
      white-space: break-spaces;
      word-break: break-word;
    }
  }
}
</style>

<style lang="scss">
.app-popover {
  &.el-popover {
    padding: 0;
    background-color: #e6e6e6;

    &.el-popper {
      .popper__arrow {
        &::after {
          border-bottom-color: #e6e6e6;
        }
      }
    }
  }
}
</style>
